import React from 'react';
import GlobalTooltip from '../../../GlobalTooltip/GlobalTooltip';
import css from '../GlobalTable.less';

import { EnumTablePosition } from 'src/types/common/common';
const characterLength = 8;
const marginPaddingWidth = 26;
const containPaddingWidth = 20;

export const clomeWidth = (columnsFilter, t, fixedWidth = 0) => {
  const tableSize = t;
  //console.log('tableSize', tableSize);
  const tableMinWidthFilter = columnsFilter.filter((column) => column.minWidth);

  const autoWidth = tableMinWidthFilter.reduce(
    (pre, current) => pre + current.minWidth,
    0,
  );

  const tableWidthFilter = columnsFilter.filter(
    (column) => (column.width || column.fixedWidth) && !column.minWidth,
  );

  const fixWidth = tableWidthFilter.reduce((pre, current) => {
    if (current.width) {
      return pre + current.width;
    }
    if (current.fixedWidth) {
      return pre + current.fixedWidth;
    }
    return pre;
  }, 0);
  columnsFilter.forEach((column) => {
    //forEach需要优化
    const allWidth = autoWidth + fixWidth + fixedWidth;
    const { position = EnumTablePosition.left, titlePosition } = column;
    // console.log('allWidth', allWidth);
    if (column.minWidth) {
      if (allWidth > tableSize) {
        //console.log('allWidth > tableSize');
        column.width = column.minWidth;
      } else {
        //console.log('allWidth < tableSize');
        const resWidth =
          (column.minWidth / autoWidth) * (tableSize - fixWidth - fixedWidth);

        // console.log('resWidth', resWidth);
        if (resWidth >= column.minWidth) {
          column.width = Math.floor(resWidth);
        } else {
          column.width = column.minWidth;
        }
      }
    }
    if (column.fixedWidth) {
      column.width = column.fixedWidth;
    }
    column.width = column.width - 0.5;
    // console.log('column', column.width);

    //console.log('---=-=-=-=', column);

    if (column.tags && column.width && column.tagsGenerator) {
      //计算tags超出显示...
      column.render = (tags = [], record) => {
        return column.tagsGenerator(
          characterLength,
          column.width,
          marginPaddingWidth,
          containPaddingWidth,
          tags,
          record,
        );
      };
    }
    if (column.width && column.mixedGenerator) {
      //计算tags超出显示...
      column.render = (data, record, index) => {
        return column.mixedGenerator(
          data,
          record,
          index,
          {
            characterLength,
            width: column.width,
            marginPaddingWidth,
            containPaddingWidth,
          },
          (children) => {
            return (
              <Container
                position={position}
                width={column.width - containPaddingWidth}>
                {children}
              </Container>
            );
          },
        );
      };
    }

    //column.width - containPaddingWidth
    // column.firstRender = true;
    if (!column.render && column.width) {
      column.render = (tags) => {
        return (
          <Container
            position={position}
            className={css.tooltipContain}
            width={column.width - containPaddingWidth}>
            <GlobalTooltip title={tags}>{tags}</GlobalTooltip>
          </Container>
        );
      }; //需要改掉
    }
    if (column.childGenerate && column.width && !column.tags) {
      const childGenerate = { ...(column || {}) }.childGenerate;

      column.render = (text, render, index) => {
        const child = childGenerate(text, render, index);
        const props = column.propsGenerate
          ? column.propsGenerate(text, render, index) || {}
          : {};
        return {
          children: (
            <Container
              position={position}
              width={column.width - containPaddingWidth}>
              {child}
            </Container>
          ),
          props,
        };
      };
    }

    if (column.titleGenerate && column.width) {
      column.title = (text, render, index) => {
        return (
          <Container
            position={titlePosition || position}
            width={column.width - containPaddingWidth}
            className={`${css.tooltipContain} table-col_title-container`}>
            {column.titleGenerate(text, render, index)}
          </Container>
        );
      };

      //没有render的列展示Tooltip
    }
  });

  return columnsFilter;
};
const Container = (props) => {
  const {
    children,
    className,
    width,
    position = EnumTablePosition.left,
  } = props;
  const cssPosition = {
    [EnumTablePosition.left]: css.left,
    [EnumTablePosition.mid]: css.mid,
    [EnumTablePosition.right]: css.right,
  }[position];

  return (
    <div
      className={`${css.colContainer} ${cssPosition} ${className || ''}`}
      style={{
        maxWidth: width,
      }}>
      {children}
    </div>
  );
};
